import React, { useContext } from 'react';
import RecipesContext from "context/RecipeContext";
import Tag from "./Tag";
import "./Topbar.css"
import { 
    removeRecipe,
    clearRecipeSet,
    removeTag
} from "common/recipe-helper";
import { updateURLParams } from "common/query-helper"
  
const RecipeTags = () => {
    const { 
        tagsSelected, 
        setTagsSelected, 
        setIsFilterRecipes,
        recipes,
        setQueryParams
    } = useContext(RecipesContext.context);

    let tags = [];

    for(const category in tagsSelected) { 
        let value = tagsSelected[category];
        if (tagsSelected !== "null") {
            for(let obj of value) {
                tags.push([category, obj.name])
            }
        }
    }

    function handleTagRemoval(category,tag){
        let filtered = removeTag(tagsSelected, category, tag);
        let updatedTagSelection = {
            ...tagsSelected,
            [category]: filtered
        }

        setTagsSelected(updatedTagSelection);
        removeRecipe(recipes,updatedTagSelection);
        clearRecipeSet(updatedTagSelection, recipes, setIsFilterRecipes);// if no tags selected, clear recipe
        setQueryParams(updateURLParams(updatedTagSelection));
    }

    let margin = tags.length > 0 ? "react-margin-btm" : "";
    return ( 
        <div className={"react-TagWrapper " + margin}>
                {tags.map((tag, index) => (
                    <Tag 
                        tag={tag} 
                        key={index} 
                        handleTagRemoval={handleTagRemoval}
                    />
                ))}
        </div>
     );
}
 
export default RecipeTags;